import { EMPTY, Observable } from 'rxjs';
import { QtSearchDirective } from '../directives';
import { defaultSearchPredicate, search } from '../utils';
import {
  PIPE_ORDER,
  QtDataSourceContext,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export class SearchAdapter implements QtDataTransformAdapter<any, null> {
  readonly key = 'search';
  readonly persistent = false;
  readonly pipeOrder = PIPE_ORDER.SEARCH;
  readonly valueChanges$: Observable<null> = EMPTY;

  private _ctx: QtDataSourceContext | null = null;

  get operator() {
    return search<any>(
      this.directive,
      this._ctx?.searchPredicate ?? defaultSearchPredicate,
      this._ctx?.valueAccessorFn ?? (() => undefined)
    );
  }

  constructor(readonly directive: QtSearchDirective) {}

  setContext(ctx: QtDataSourceContext): void {
    this._ctx = ctx;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  applyValue(_: null): void {}

  getValue(): null {
    return null;
  }
}
